export default __webpack_public_path__ + "static/logo-b36dcf1ac540aa470221a62437dc7a71.png";